import { graphql } from "msw";
import { generateRemoveItemMock } from "../utilities/generateRemoveItemMock";
import { mockCart } from "./mockCart";
import { mockOnePassSubscription } from "./mockOnePassSubscription";
import {
  ONEPASS_MONTHLY_OFFER_ID,
  ITEM_ID_THAT_WILL_THROW_ERROR,
  OFFER_ID_THAT_WILL_THROW_ERROR,
  TEST_ERROR_MESSAGE,
} from "@cart-app/mocks/constants";
import {
  RemoveItemFromCartMutationVariables,
  RemoveItemFromCartMutation,
} from "@cart-app/generated/graphql";

export const handler = graphql.mutation<
  RemoveItemFromCartMutation,
  RemoveItemFromCartMutationVariables
>("RemoveItemFromCart", (req, res, ctx) => {
  const { itemId, offerId } = req.variables;

  // Missing ID triggers Apollo Client server error.
  if (!itemId && !offerId) {
    return res(
      ctx.errors([
        {
          message: "Cart item ID not provided",
        },
      ])
    );
  }

  // Certain itemId or offerId will trigger UserError.
  if (
    itemId == ITEM_ID_THAT_WILL_THROW_ERROR ||
    offerId == OFFER_ID_THAT_WILL_THROW_ERROR
  ) {
    return res(
      ctx.data({
        removeItemFromCart: {
          __typename: "UserError" as const,
          message: TEST_ERROR_MESSAGE,
        },
      })
    );
  }

  // OnePass remove item error.
  if (offerId == OFFER_ID_THAT_WILL_THROW_ERROR) {
    return res(
      ctx.data({
        removeItemFromCart: {
          __typename: "UserError" as const,
          message: "Sorry, cannot remove this item from the cart.",
        },
      })
    );
  }

  // Removing the OnePass item.
  if (offerId == ONEPASS_MONTHLY_OFFER_ID) {
    return res(
      ctx.data({
        removeItemFromCart: {
          ...mockCart,
          clubSubscription: {
            ...mockOnePassSubscription,
            selectedOption: null,
            offerUpsell: true,
          },
        },
      })
    );
  }

  // Removing a normal item.
  return res(
    ctx.data({
      removeItemFromCart: {
        ...generateRemoveItemMock({
          id: itemId,
        }),
      },
    })
  );
});
